import React, { useEffect, useRef, useState } from "react";

import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch } from "react-redux";

import Layout from "components/Layout";

import EmphasisText from "components/EmphasisText";

import LeonardoLanguageToggle from "components/LeonardoLanguageToggle";

import api from "utils/api";
import { queueAuthSuccessPopup } from "utils/authSuccessPopup";

import { useLeonardoLocale } from "scenes/leonardoNikolai/LeonardoLocaleContext";

import { createTranslator } from "scenes/leonardoNikolai/i18n";

import { normalizePreferredLanguage } from "utils/preferredLanguage";

import { setLogin } from "state";

import {
  claimCampaignCreditIfEligible,
  getCampaignFromLocation,
  isCampaignCreditOffer,
  queueCampaignCreditPopup,
} from "utils/campaignCredit";

import "styles/auth.css";



const LEONARDO_NIKOLAI_SOURCE = "leonardo-nikolai";

const LEONARDO_NIKOLAI_PATH = "/leonardo-nikolai";

const LEONARDO_NYX_SOURCE = "leonardo-nyx";

const LEONARDO_NYX_PATH = "/leonardo-nyx";


const isLeonardoUser = (user) => {

  const source = String(user?.source || "").trim().toLowerCase();

  if (source === LEONARDO_NIKOLAI_SOURCE || source === LEONARDO_NYX_SOURCE) return true;
  const path = String(user?.registrationPath || "").trim().toLowerCase();

  return (
    path === LEONARDO_NIKOLAI_PATH ||
    path.startsWith(`${LEONARDO_NIKOLAI_PATH}/`) ||
    path === LEONARDO_NYX_PATH ||
    path.startsWith(`${LEONARDO_NYX_PATH}/`)
  );
};

const VERIFY_SUCCESS_DESTINATION = "/";



const VerifyEmailPage = () => {

  const [params] = useSearchParams();

  const token = params.get("token") || "";
  const requestedNext = params.get("next") || "";
  const successDestination =
    requestedNext.startsWith("/") && !requestedNext.startsWith("//")
      ? requestedNext
      : VERIFY_SUCCESS_DESTINATION;

  const isEmailChange =

    params.get("zweck") === "email-aendern" || params.get("purpose") === "email-change";

  const { shellT, isLeonardoFlow } = useLeonardoLocale();

  const [status, setStatus] = useState({

    kind: "loading",

    message: isEmailChange

      ? shellT("shell.auth.verify.loadingEmailChange")

      : shellT("shell.auth.verify.loading"),

  });

  const [leonardoVerified, setLeonardoVerified] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const ranRef = useRef(false);



  useEffect(() => {

    if (!token) {

      setStatus({

        kind: "error",

        message: shellT("shell.auth.verify.incomplete"),

      });

      return;

    }

    if (ranRef.current) return;

    ranRef.current = true;

    (async () => {

      try {

        const endpoint = isEmailChange ? "/auth/verify-email-change" : "/auth/verify-email";

        const { data } = await api.get(endpoint, { params: { token } });

        let user = data.user;
        if (!isEmailChange) {
          if (data.campaignCredit?.credited) {
            queueCampaignCreditPopup({
              campaign: data.campaignCredit.campaign,
              creditCents: data.campaignCredit.creditCents,
            });
          } else {
            const campaign =
              getCampaignFromLocation({ search: window.location.search }) ||
              user?.source;
            if (isCampaignCreditOffer(campaign)) {
              const credit = await claimCampaignCreditIfEligible(campaign, {
                token: data.token,
              });
              if (credit?.user) user = credit.user;
            }
          }
        }

        dispatch(setLogin({ token: data.token, user }));
        queueAuthSuccessPopup("login");



        const leonardo = isLeonardoUser(data.user) || isLeonardoFlow;

        setLeonardoVerified(leonardo);


        const messageT = leonardo

          ? createTranslator(normalizePreferredLanguage(data.user?.preferredLanguage))

          : shellT;



        const successMessage =

          data.activatedBookings > 0

            ? messageT("shell.auth.verify.successBooking")

            : isEmailChange

              ? messageT("shell.auth.verify.successEmailChange")

              : messageT("shell.auth.verify.success");



        setStatus({

          kind: "success",

          message: successMessage,

        });



        window.setTimeout(() => {
          navigate(successDestination, { replace: true });
        }, 1500);

      } catch (err) {

        setStatus({

          kind: "error",

          message:

            err?.response?.data?.message || shellT("shell.auth.verify.invalid"),

        });

      }

    })();

  }, [

    token,

    isEmailChange,

    dispatch,

    navigate,

    isLeonardoFlow,

    shellT,
    successDestination,

  ]);



  const showLeonardoUi = isLeonardoFlow || leonardoVerified;



  return (

    <Layout>

      <section className="auth-page">

        <div className="auth-card">

          {showLeonardoUi && (

            <div className="auth-lang-toggle-row">

              <LeonardoLanguageToggle />

            </div>

          )}

          <div className="auth-kicker">{shellT("shell.auth.verify.kicker")}</div>

          <h1>

            <EmphasisText text={shellT("shell.auth.verify.title")} />

          </h1>

          <div className={`auth-alert is-${status.kind === "loading" ? "info" : status.kind}`}>

            {status.message}

          </div>

          <div className="auth-links">

            {status.kind === "success" ? (

              <Link to={successDestination}>
                {successDestination.startsWith("/buchen") ? "Zur Buchung" : "Weiter"}
              </Link>

            ) : (

              <Link to="/einloggen">{shellT("shell.auth.verify.backToLogin")}</Link>

            )}

          </div>

        </div>

      </section>

    </Layout>

  );

};



export default VerifyEmailPage;


